import React, { useEffect, useState } from 'react';

const ConfigSelector = ({ onSelect }) => {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedConfig, setSelectedConfig] = useState(''); // State to track selected config

  useEffect(() => {
    const fetchConfigs = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          console.error('No auth token found. Redirecting to login.');
          window.location.href = '/login';
          return;
        }

        const response = await fetch('/api/user-configs', {
          headers: {
            'Authorization': `Bearer ${token}` // Include the token
          }
        });

        if (response.status === 403) {
          console.error('Access forbidden: Invalid or expired token. Redirecting to login.');
          window.location.href = '/login';
          return;
        }

        if (response.headers.get('Content-Type')?.includes('application/json')) {
          const data = await response.json();
          if (Array.isArray(data)) {
            setConfigs(data);
          } else if (data && typeof data === 'object') {
            setConfigs([data]); // Wrap the object in an array
          } else {
            console.error('Unexpected data format:', data);
            setConfigs([]); // Fallback to an empty array
          }
        } else {
          throw new Error('Invalid JSON response');
        }
      } catch (error) {
        console.error('Error fetching configs:', error);
        setConfigs([]); // Fallback to an empty array in case of error
      } finally {
        setLoading(false);
      }
    };

    fetchConfigs();
  }, []);

  const handleChange = (value) => {
    setSelectedConfig(value); // Update the selected config state
    onSelect(value); // Notify the parent component about the new selection
  };

  useEffect(() => {
    if (selectedConfig) {
      onSelect(selectedConfig); // Trigger reloading of elements when a new config is selected
    }
  }, [selectedConfig, onSelect]);

  return (
    <div className="config-selector">
      <h3>Select Configuration</h3>
      {/* Logout button removed, now handled in Dashboard */}
      {loading ? (
        <p>Loading configurations...</p>
      ) : (
        <select value={selectedConfig} onChange={(e) => handleChange(e.target.value)}>
          <option value="">Choose a configuration</option>
          {Array.isArray(configs) && configs.map((config) => (
            <option key={config.id} value={config.id}>
              {config.config_name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default ConfigSelector;
